import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-account-qr-code-modal',
  templateUrl: './account-qr-code-modal.component.html',
  styleUrls: ['./account-qr-code-modal.component.scss'],
  standalone: false,
})
export class AccountQrCodeModalComponent {
  constructor(private modalCtrl: ModalController) {}

  @Input() qrCodeInfo: string | null = null;

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
